import { render, staticRenderFns } from "./StoreLarge.vue?vue&type=template&id=98bc0cda&"
import script from "./StoreLarge.vue?vue&type=script&lang=js&"
export * from "./StoreLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports